const IOS_APP_STORE_URL =
    process.env.REACT_APP_IOS_APP_STORE_URL ||
    'https://apps.apple.com/us/app/trampoline-health/id6738373037';

const TRIAL_FALLBACK_URL = 'https://www.trampolinehealth.co/trial/';

function isMobileUserAgent() {
    if (typeof navigator === 'undefined') return false;
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

function defaultLabelForLink(link) {
    const normalized = String(link || '').toLowerCase();
    if (normalized.includes('lock-card')) return 'Set up focus block';
    return 'Open in app';
}

/**
 * Normalize goal action fields from dailyfetch / selectedGoal.
 */
export function parseDailyGoalAction(source) {
    if (!source || typeof source !== 'object') {
        return { link: '', label: '' };
    }
    const link = String(source.actionLink || source.link || '').trim();
    const label = String(source.actionLabel || source.label || '').trim();
    return {
        link,
        label: label || (link ? defaultLabelForLink(link) : ''),
    };
}

/**
 * Open trampolinehealth:// deep links (iOS app) with App Store / trial fallback on web.
 * https: links open in a new tab.
 */
export function openTrampolineLink(rawLink) {
    const link = String(rawLink || '').trim();
    if (!link) return;

    if (/^https?:\/\//i.test(link)) {
        window.open(link, '_blank', 'noopener,noreferrer');
        return;
    }

    if (!/^trampolinehealth:\/\//i.test(link)) {
        console.warn('Unsupported action link:', link);
        return;
    }

    const mobile = isMobileUserAgent();
    const storeOrTrial = IOS_APP_STORE_URL || TRIAL_FALLBACK_URL;

    if (!mobile) {
        window.open(storeOrTrial, '_blank', 'noopener,noreferrer');
        return;
    }

    let fallbackTimerId = null;
    let cancelled = false;

    const cancelFallback = () => {
        if (cancelled) return;
        cancelled = true;
        if (fallbackTimerId != null) {
            window.clearTimeout(fallbackTimerId);
            fallbackTimerId = null;
        }
        document.removeEventListener('visibilitychange', onVisibilityChange);
        window.removeEventListener('pagehide', cancelFallback);
        window.removeEventListener('blur', cancelFallback);
    };

    const onVisibilityChange = () => {
        if (document.hidden) cancelFallback();
    };

    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('pagehide', cancelFallback);
    window.addEventListener('blur', cancelFallback);

    window.location.href = link;

    fallbackTimerId = window.setTimeout(() => {
        fallbackTimerId = null;
        if (cancelled || document.hidden) return;
        window.location.href = storeOrTrial;
    }, 1500);
}

export { defaultLabelForLink, IOS_APP_STORE_URL };
